import React, { useEffect, useState } from 'react';

import './CatalogView.css'
import { authFecth } from '../../../scripts/requests';

const CatalogView = ({ fetchUrl, filter, catalogBox, fetchArgs, refresh, exclude=[]}) => {

    const boxesPerView = 8;

    const [objs, setObjs] = useState([]);
    const [cursor, setCursor] = useState(0);
    function fetch_objs () {
        authFecth(fetchUrl, "GET", {filter: filter, ...fetchArgs})
            .then(res => {
                if (!res.ok) { 
                return res.json().then(data => {
                    throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
                }
                return res.json();
            })
            .then(data => {
                if (exclude.length !== 0) {
                    setObjs(data.filter(service => !exclude.includes(service.service_id)))
                }
                else {
                    setObjs(data);
                }
            })
            .catch(error => {
                console.error("Error fetching user:", error);
            });
        }

        function get_row(rows_amount, column) {
            const rows = [];
            for (let row = 0; row < rows_amount; row++){
                if (column + row < objs.length) {
                    rows.push(
                        catalogBox(objs[column + row])
                    )
                }
            }
            return rows;
        }
        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
            }

        function moveBack() {
             if (cursor > 0) {
                    setCursor(cursor - boxesPerView);
                }
        }

        async function moveForward() {
            if (cursor + boxesPerView < objs.length) {
                    setCursor(cursor + boxesPerView);
                }
        }

        function get_columns(rows) {
            const colunms = [];
            for (let index = cursor; index < cursor + boxesPerView; index += rows) {
                colunms.push(
                <div >
                    {get_row(rows, index)}
                </div>);
                }
            return colunms;
        }
    
    useEffect(fetch_objs, [filter, refresh]);
    return (
            <div className='catalog-view-page'>
                <div className='catalogs-view-columns-container'>
                    {get_columns(2)}
                </div>
                {  objs.length > boxesPerView &&
                    <div className='move'>
                        <div onClick={moveBack} className='move-back'>{"<"}</div>
                        <label>{(cursor / boxesPerView) + 1}/{Math.ceil(objs.length / boxesPerView)}</label>
                        <div onClick={moveForward} className='move-forward'>{">"}</div>
                    </div>
                }
            </div>
    );
};

export default CatalogView;